import List from './List';
import Create from './Create';
import Edit from './Edit';
import Show from './Show';
import { gql } from '@apollo/client';

export default {
  name: 'administrators',
  inputShow: gql`
    query administrators($input: AdministratorQueryInput) {
      administrators(input: $input) {
        id
        account {
          id
          first_name
          last_name
          name
        }
        __typename
      }
    }
  `,
  list: List,
  create: Create,
  edit: Edit,
  show: Show,
  options: {
    group: 'Misc',
    label: 'Administrators',
  },
};
